import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { tagActions } from '../../store/modules/tag';
import { appActions } from '../../store/modules/app';
import {
  TAG_LIST_SEARCH_DATA_MODEL,
  TAG_LIST_SEARCH_OPTION_MODEL,
  TAG_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/tag/models';
import TagListWrap from '../../views/tag/list/TagListWrap';

class TagListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: TAG_LIST_SEARCH_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: TAG_LIST_SORT_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
      isInit: true,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['tagList', 'searchData'],
      value: TAG_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = async (data) => {
    const { getTagList, tagList } = this.props;
    const { searchOption, sortOption, pagination } = tagList;

    getTagList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   *  엑셀 다운로드
   */
  getTagListExcelDownload = () => {
    const { getTagListExcelDownload, tagList } = this.props;
    const { searchOption, sortOption, pagination } = tagList;

    getTagListExcelDownload({
      searchOption,
      sortOption,
      pagination,
    });
  };

  render() {
    const { tagList, tagGroupSelectList, setData, getRelatedTagList } = this.props;

    return (
      <TagListWrap
        tagList={tagList}
        tagGroupSelectList={tagGroupSelectList}
        setData={setData}
        getRelatedTagList={getRelatedTagList}
        getList={this.getList}
        getTagListExcelDownload={this.getTagListExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tagList: state.tag.tagList,
    tagGroupSelectList: state.tag.tagGroupSelectList,
  };
};

const mapDispatchToProps = {
  setData: tagActions.setData,
  getTagList: tagActions.getTagList,
  getTagListExcelDownload: tagActions.getTagListExcelDownload,
  getRelatedTagList: appActions.getRelatedTagList,
};

export default connect(mapStateToProps, mapDispatchToProps)(TagListContainer);
